export { default as HeaderComponent } from './components/HeaderComponent.vue';
export { default as SingleSelectDropdown } from './components/SingleSelectDropdown.vue';
export { default as SelectableTags } from './components/SelectableTags.vue';
export { default as MenuLateral } from './components/MenuLateral.vue';
export { default as PageTitle } from './components/PageTitle.vue';
export { default as SimpleModal } from './components/SimpleModal.vue';
export { default as ActionModal } from './components/ActionModal.vue';
export { default as SearchableSelect } from './components/SearchableSelect.vue';
export { default as PaginationComponent } from './components/PaginationComponent.vue';
export { default as ChamarDemanda } from './components/ChamarDemanda.vue';
export { default as ModalNovaOSAssistenciaTecnica } from './components/ModalNovaOSAssistenciaTecnica.vue';
export { default as ModalDetalheOsAssistenciaPosVenda } from './components/ModalDetalheOsAssistenciaPosVenda.vue';

export {
  buscarProdutosOs2,
  calcularDtFimPrevisto7DiasUteis,
  criarAssistenciaEmAnalise,
  listarClientesOsAssistencia,
  listarOsAssistenciaPorPosVenda,
  listarPosVendasOsAssistencia,
  obterOsAssistenciaDetalhe,
  atualizarCabecalhoOsAssistenciaPosVenda,
  urlEditarOsAssistenciaDemandas,
} from './services/os2AssistenciaOrdemServicoService';

export { usePermissions, permissionsStore } from './store/permissionsStore';

import pkg from '../package.json';
export const COMPONENTES_LIB_VERSION = pkg.version;

import './style.css'